export default "__VITE_ASSET__kaMBtz_N__"